export { getAvailableStrengths } from "./getAvailableStrengths";
